import React, { useEffect, useState } from 'react';
import { Box, Container, Typography } from '@material-ui/core';

import Header from '../components/Header';
import Section from '../components/Section';
import PreFooter from '../components/PreFooter';
import Footer from '../components/Footer';
import BlockViewer from '../components/BlockViewer';
import { fetch } from '../services/about';

const About = () => {
  const [content, setContent] = useState<string>('');
  useEffect(() => {
    const fetchData = async () => {
      const data = await fetch();
      setContent(data?.content);
    };
    fetchData();
  }, []);

  return (
    <>
      <Header />
      <Container maxWidth='md'>
        <Section minHeight={400}>
          <Box display='flex' justifyContent='center' alignItems='flex-end'>
            <Box mb={2} flexGrow={1} borderBottom='solid 2px #81E6D9' />
            <Box px={2}>
              <Typography variant='h4'>เกี่ยวกับเรา</Typography>
            </Box>
            <Box mb={2} flexGrow={1} borderBottom='solid 2px #81E6D9' />
          </Box>
          <Box height={32} />
          {content !== '' && <BlockViewer content={JSON.parse(content)} />}
        </Section>
      </Container>
      <PreFooter />
      <Footer />
    </>
  );
};

export default About;
